

import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';
import {smartAddEventListener} from '../../../vendor/scripts/fabrique/helpers/eventlisteners';

class HomeIntro extends Component {

  constructor() {
    super(...arguments);
  }

  init() {
    this.onKeyDown = (event) => {

      if (this.stage !== 0) {
        return;
      }

      if (event.keyCode === 32 || event.keyCode === 36 && event.keyCode === 40) { // SpaceBar or page down or arrow down
        event.preventDefault();
        this.end();
      }

    };

    this.onButtonClick = (event) => {

      if (this.stage !== 0) {
        return;
      }

      event.preventDefault();
      this.end();

    };

    this.onScroll = () => {

      window.scrollTo(0, 0);

    };

    this.onWheel = (event) => {

      event.preventDefault();

    };

    this.onResize = () => {

      this.element.style.height = `${window.innerHeight}px`;

    };

    this.stage = 0;

    smartAddEventListener(window, 'mousewheel DOMMouseScroll', this.onWheel);
    window.addEventListener('keydown', this.onKeyDown);
    this.element.querySelector('[data-role="skip-intro"]').addEventListener('click', this.onButtonClick.bind(this));
    window.addEventListener('resize', this.onResize);

    this.scrollToTop().then(() => {
      window.addEventListener('scroll', this.onScroll);
    });

    this.onResize();
    setTimeout(() => {
      if (this.stage === 0) {
        this.end();
      }
    }, 5000);
  }

  /**
   * Remove any event listeners of this component.
   */
  destroy() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('mousewheel', this.onWheel);
    window.removeEventListener('DOMMouseScroll', this.onWheel);
    window.removeEventListener('resize', this.onResize);
    this.element.querySelector('[data-role="skip-intro"]').removeEventListener('click', this.onButtonClick);
  }

  /**
   * End the intro
   */
  end() {
    this.stage = 1;
    this.element.classList.add('is-ending');

    setTimeout(() => {
      if (this.stage === 1) {
        this.element.classList.add('is-ended');
        fireCustomEvent('intro:ended');
        this.destroy();
      }
    }, 400);
  }

  /**
   * Scroll to top as soon as possible.
   *
   * @returns {Promise<any>}
   */
  scrollToTop() {
    return new Promise((resolve) => {
      this.initialToTopScroller = setInterval(() => {
        if (window.pageYOffset !== 0) {
          window.scrollTo(0, 0);
        } else {
          clearInterval(this.initialToTopScroller);
          resolve();
        }
      }, 100);
    });
  }
}

for (const element of document.querySelectorAll('.home-intro')) {
  element.instance = new HomeIntro('home-intro', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/home-intro/home-intro.js